import { render } from "./PackageParameter.vue?vue&type=template&id=79388c01"
import script from "./PackageParameter.vue?vue&type=script&lang=js"
export * from "./PackageParameter.vue?vue&type=script&lang=js"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__